import isNull from "lodash/isNull";
import remove from "lodash/remove";
import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

import { bugNotif } from "../../api/bugsnag";
import { getErrorMsg, useEffectOnlyOnce } from "../../../Common/utils/common";
import { getUserSubscriptionListStripe } from "../../services/subscription";
import { useWebUserStore } from "../user/users";
import { shallow } from "zustand/shallow";
import { GLOBAL_QUERY_KEY } from "..";
import useUserSubscriptionsStore from "./store";

export const useUserSubscriptionsProvider = (): void => {
  const user = useWebUserStore((store) => store.user, shallow);

  const { data, error } = useQuery({
    queryKey: [GLOBAL_QUERY_KEY.subscriptionList, user],
    queryFn: async () => {
      if (!user) {
        return;
      }
      const resp = await getUserSubscriptionListStripe(user);
      return resp;
    },
    refetchOnWindowFocus: true,
  });

  useEffect(() => {
    if (!isNull(error)) {
      bugNotif(
        "useUserSubscriptionsProvider - getSubscriptions",
        getErrorMsg(error).rawErrorMsg
      );
    }
  }, [error]);

  const [setSubscriptionList, setPowerUpList, resetStore] =
    useUserSubscriptionsStore(
      (store) => [
        store.setSubscriptionList,
        store.setPowerUpList,
        store.resetStore,
      ],
      shallow
    );

  useEffect(() => {
    if (data !== undefined) {
      const subscriptionList = [...data];
      const powerUps = remove(subscriptionList, (sub) => sub.isOneOff);
      setSubscriptionList(subscriptionList);

      setPowerUpList(powerUps);
    }
  }, [data]);

  useEffectOnlyOnce(() => {
    return () => {
      resetStore();
    };
  });
};
